import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import {transformValueFloattoFormated, MaskOnlyNumbersStart1} from "beaktShared/helpers/masks";
import CircularProgress from '@material-ui/core/CircularProgress';
import PedidoCompraPagamento from "beaktClinic/views/Estoque/PedidoCompraPagamento";

// icons
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import selectmultTable from "assets/jss/BeaktShared/selectmultTable";

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(selectmultTable);

export default function PedidoCompra() {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const classes = useStyles();
    const classes2 = useStyles2();

    const [showPagamento, setshowPagamento] = React.useState(false);
    const { register, handleSubmit, setValue, errors, setError, clearError, getValues } = useForm({mode: "onChange"});
    const [loading,setloading] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [alert,setalert] = React.useState();
    const showAlert = (message, tipo) => {        
        setalert(<SweetAlert
          error={tipo=='error'?true:false}
          warning={tipo=='warning'?true:false}
          success={tipo=='success'?true:false}
          title="Aviso"
          onConfirm={() => setalert(null)}
        >  
        <div dangerouslySetInnerHTML={{ __html: message}} /> 
        </SweetAlert> );
    };
    
    const [totalPedido, settotalPedido] = React.useState(0);    

    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);    
    const [franquia, setfranquia] = React.useState(0);
    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);        
        let endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;        
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')
            setisLoadingEstabelecimento(false);
            return false;
        }

        setisLoadingEstabelecimento(false);
        setestabelecimentos(result.data);
        return true;
        });        
    };
    const LoadFranquiaId = () => {
        setisLoadingEstabelecimento(true);
        let endPoint = "estabelecimentos/"+session.estabelecimentoId;        
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')
            setisLoadingEstabelecimento(false);
            return false;
        } 
        setfranquia(result.data.franquiaId);   
        setisLoadingEstabelecimento(false);            
        return true;
        });
    };

    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value.estabelecimentoId);        
        setValue("estabelecimento", value.estabelecimentoId);
        if (value !== "")
            clearError("estabelecimento");
    };
    useEffect(() => {
        loadSelectProdutos();         
    }, [franquia]);

    const [listSelectProdutosSelected, setlistSelectProdutosSelected] = React.useState([]);
    const [produtos, setprodutos] = React.useState([]);
    const [listSelectProdutos, setlistSelectProdutos] = React.useState([]);
    const [loadingSelectProdutos, setloadingSelectProdutos] = React.useState(false);   
    
    const loadSelectProdutos = () =>{   
        setprodutos([]); 
        setlistSelectProdutosSelected([]);  
        setlistSelectProdutos([]);
        
        let endPoint = "produtos/ativos/byfranquia/";
        if (session.franquiaId != null && session.franquiaId != 0)
            endPoint += session.franquiaId;
        else
            endPoint += franquia;

        setloadingSelectProdutos(true);   
        UseGetApiSimple(endPoint,0).then(result=>{                   
            if(result.status !== 200)
            {                                                     
                setloadingSelectProdutos(false); 
                return false; 
            }     
            setlistSelectProdutos(result.data);  
            setloadingSelectProdutos(false); 
            return true;                
        });  
    }
    const handleProdutoChange = event => {
        let value = event        
        let lstProdutosAdd = [];
        let lstProdutosSelect = [];
        value.map(item =>{
            lstProdutosAdd.push(item.produtoId); 
           
            let qtdExist = listSelectProdutosSelected.filter(obj => {
                return obj.produtoId === item.produtoId
            });

            if (qtdExist.length > 0) qtdExist = qtdExist[0].quantidadeSolicitada;
            else qtdExist = 1;
           
            lstProdutosSelect.push({
                produtoId:item.produtoId,
                descricao: item.descricao,
                quantidadeSolicitada:qtdExist,
                valorUnitario: item.valorCusto
            });                          
        });
        setprodutos(lstProdutosAdd); 
        setlistSelectProdutosSelected(lstProdutosSelect);  
    }; 

    const changeQtdProduto = (e,produtoId) =>{
        let vefifyExists = listSelectProdutosSelected.filter(obj => {
            return obj.produtoId === produtoId;
        });

        if(vefifyExists.length > 0)
        {
            vefifyExists[0].quantidadeSolicitada = parseInt(e.target.value);
            let listatualizada = listSelectProdutosSelected.map(l => (l.produtoId === vefifyExists[0].produtoId ? vefifyExists[0] : l));
            setlistSelectProdutosSelected(listatualizada);                        
        }
    }
    useEffect(() => {
        let total = listSelectProdutosSelected.reduce((a,b) => a + (b.valorUnitario * b.quantidadeSolicitada),0);            
        settotalPedido(total);
    },[listSelectProdutosSelected]);

    useEffect(() => {        
        if (session.estabelecimentoId === 0)
            LoadEstabelecimentos();
        else            
            LoadFranquiaId();                 
    }, []);

    const handleCancelar = () => {
        window.location.reload();
    }

    const [pedido, setpedido] = React.useState({});
    const onSubmit = data => {  
        let pedido = {
            EstabelecimentoId: (session.estabelecimentoId === 0 ? estabelecimento : session.estabelecimentoId),
            UsuarioPedidoId: session.id, 
            PagamentoEfetuado: 0,            
            PedidoCompraItens: listSelectProdutosSelected,
            totalPedido: totalPedido
        }
        
        if (session.estabelecimentoId === 0 && (estabelecimento === "" || estabelecimento === 0)){
            setError("estabelecimento","required");
            return false;
        }
        

        if (listSelectProdutosSelected.length === 0)
        {
            showNotification("Informe os produtos a serem enviados!", "warning")
            return false;
        }        
        
        if (session.estabelecimentoId === 0){
            setloading(true);
            UsePostApi("pedidocompra", pedido).then(result => {
                setloading(false);
                if (result.status !== 200) {
                    showAlert(result.message, "error");
                    return false;
                }          

                if (result.data.statusPedido === 4)                
                    showAlert("Pedido de compra gerado com sucesso. Estamos processando seu pagamento, acompanhe o andamento do pagamento pela tela de Gestão de Pedidos!", "warning");                
                else if (result.data.statusPedido === 5)
                    showAlert("Não foi possível efetuar o pagamento do seu pedido!", "danger");                
                else 
                {
                    showAlert("Pedido de compra gerado com sucesso!", "success");                
                    setestabelecimento(0);                       
                    setprodutos([]);
                    setlistSelectProdutosSelected([]);
                }
                return true;
            });
        }
        else{
            setpedido(pedido);
            setshowPagamento(true);
        }     
    }

    return (
        <div className="maxContent">             
            {showPagamento &&
                <PedidoCompraPagamento pedidocompra={pedido}></PedidoCompraPagamento>            
            }
            {!showPagamento &&
                <form onSubmit={handleSubmit(onSubmit)}>
                {notification.show &&
                    <div><br/>
                    <SnackbarContent
                        message={notification.message}
                        color={notification.color}
                        closeNotification={() => setNotification({show:false})}
                        close
                    /></div>}                        
                <GridContainer>
                    {loading && 
                        <div className="carregandoCmp">
                            <div className="box">
                                <label>{t('label.loading')}...</label>
                                <CircularProgress />
                            </div>
                        </div> 
                    }
                    {alert}
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <ShoppingCartIcon />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('sidebar.purchase_order')} - <small>{t('information_message.fill_the_products')}</small>                                
                                </h4>
                            </CardHeader>
                            <CardBody>
                                {session.estabelecimentoId === 0 &&
                                    <GridContainer>
                                        <GridItem xs={12} sm={6} md={4}>                
                                            <FormControl fullWidth className={classes.formControl}>
                                            <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>
                                                {t('label.establishment')} *</label>
                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.estabelecimento ? true : false)}
                                                isSearchable={true}
                                                isLoading={isLoadingEstabelecimento}
                                                name="estabelecimento"
                                                placeholder={t('label.select')+"..."}
                                                options={estabelecimentos}
                                                value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                onChange={(value) => handleEstabelecimentoChange(value)}
                                                ref={() => register({ name: "estabelecimento" })
                                                }
                                            />
                                            {errors.estabelecimento &&
                                            <FormHelperText>
                                                <span className="obg"> {t('label.required')} </span>
                                            </FormHelperText>}
                                            </FormControl>                    
                                        </GridItem>                                                                
                                    </GridContainer>
                                }
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>                                 
                                        <FormControl fullWidth className={classes.formControl}>  
                                            <label className={errors.produtos?"select__label select__label_error":"select__label"}>
                                                {t('dashboard.products')}  </label>
                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.produtos?true:false)}   
                                                isSearchable={true}
                                                isLoading={loadingSelectProdutos}
                                                name="produtos"
                                                placeholder={t('label.select')+"..."}
                                                isMulti={true}
                                                options={listSelectProdutos}     
                                                getOptionLabel={({descricao}) => descricao}
                                                getOptionValue={({produtoId}) => produtoId} 
                                                value={listSelectProdutos.filter(({produtoId}) => produtos.indexOf(produtoId) != -1)}
                                                onChange={(value) => handleProdutoChange(value || [])}
                                                ref={() => register( { name: "produtos" })}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.produtos && <span> {t('label.required')} </span>}
                                            </FormHelperText>    
                                        </FormControl>  
                                        <br/>
                                        {listSelectProdutosSelected.length > 0 &&                                                                                
                                        <div>
                                            <h5>
                                                {t('label.selected_products')}
                                            </h5>
                                            <div className={classes2.boxSelectedBefore}>                                                                                                                            
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th className={classes2.thQtd}> <b> {t('label.qty')}</b> </th>
                                                        <th className={classes2.thDesc}> <b> {t('label.description')}</b> </th>
                                                        <th className={classes2.thDesc}> <b> {t('label.value_cost')}</b> </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {listSelectProdutosSelected.map(item => (     
                                                    <tr key={item.produtoId}>
                                                        <td>
                                                            <TextField                                        
                                                                error={errors.qtdprod?true:false}
                                                                variant="outlined"                                    
                                                                inputRef={register({required: true})}
                                                                type="number"
                                                                name="qtdprod"
                                                                defaultValue={item.quantidadeSolicitada}   
                                                                InputLabelProps={{shrink: true}}  
                                                                inputProps={{maxLength: 3}} 
                                                                onInput={(e) => MaskOnlyNumbersStart1(e) }    
                                                                onChange={(e) => changeQtdProduto(e,item.produtoId)}
                                                            />
                                                            <FormHelperText className={classes.labelRootError}>
                                                                {errors.qtdprod && <span> {t('label.required')} </span>}
                                                            </FormHelperText>   </td>
                                                        <td>
                                                            <div className={classes2.detailDesc}>
                                                                {item.descricao} 
                                                            </div> 
                                                        </td>
                                                        <td>
                                                            <div className={classes2.detailDesc}>
                                                                {transformValueFloattoFormated(item.valorUnitario)} 
                                                            </div> 
                                                        </td>
                                                    </tr>
                                                ))}                                               
                                                </tbody>
                                            </table>                                            
                                        </div>     
                                        <h5 style={{textAlign:"right"}}><strong>{t('stock.total_order')}: {t('label.money_symbol')}{transformValueFloattoFormated(totalPedido)}</strong></h5>
                                        </div>                                        
                                        }                                         
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <br/>
                        <div className={classes.textCenter}>
                            <Button  color="transparent" className={classes.updateProfileButton} onClick={() => handleCancelar()}>
                             {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                             {t('button.to_save')}                          
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>            
                </form>
            }
        </div>
    );
}